import { Typography } from 'antd';
import classnames from 'classnames';
import React, { useState } from 'react';
import { pickDomAttrs } from '../_util/utils';
import Tooltip from '../tooltip';
import './style/index';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  Paragraph
} = Typography;
const getIsI18nChildren = children => {
  return /\{\{\{.+\}\}\}/.test(children);
};
const EllipsisTooltip = _ref => {
  let {
    tooltip = true,
    width,
    children,
    placement,
    getPopupContainer,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    style,
    className,
    overlayStyle,
    ...restProps
  } = _ref;
  const baseClassName = "".concat(prefixClass, "-ellipsisTooltip");
  const attrs = pickDomAttrs(restProps);
  const [ellipsisFlag, setEllipsisFlag] = useState(false);
  if (children === undefined) {
    return null;
  }
  return /*#__PURE__*/_jsx(Tooltip, {
    title: ellipsisFlag && tooltip ? children : undefined,
    placement: placement,
    overlayStyle: overlayStyle,
    getPopupContainer: getPopupContainer,
    children: /*#__PURE__*/_jsx(Paragraph, {
      ...attrs.data,
      className: classnames(baseClassName, className),
      style: {
        width,
        lineHeight: 1.571429,
        ...style
      },
      ellipsis: getIsI18nChildren(children) ? false : {
        rows: 1,
        onEllipsis: flag => {
          setEllipsisFlag(flag);
        }
      },
      children: children
    })
  });
};
export default EllipsisTooltip;